import { useState } from 'react';
import useSound from 'use-sound';
import correctAnswerBling from '../../sounds/correctAnswerBling.wav'
// import wrongAnswerBuzz from '../../sounds/wrongAnswerBuzz.wav'
import wrongAnswerBuzz from '../../sounds/fail.mp3'


import { data } from './data/data_03_sauvat_matala_plusplus.js'

import kuva from './images/matala1_400x700.png'

const SauvatMatalaPlusplus = ({ visibilityHandler, soundsOn }) => {


    // Vastausvaihtoehtojen ääniefektit
    const [playCorrectAnswer] = useSound(correctAnswerBling);
    const [playWrongAnswer] = useSound(wrongAnswerBuzz);


    function Reset() {

        // alert("Sauvat matala ++ --> Säädetäänpäs uudelleen...,")
        visibilityHandler("Säädetään uudelleen")

    }


    return (

        <div className='sceneContainer'>

            <div id='image'>

                <img src={kuva} alt="kuva" style={{ width: '280px' }} />


            </div>

            <div id='question'>
                <h5>{(data.kysymysteksti != null && data.kysymysteksti != "") ? data.kysymysteksti : null}</h5>
            </div>

            <div id='actions'>
                <button onClick={() => Reset()}>Säädä uudelleen</button>


            </div>
        </div>
    )

}

export default SauvatMatalaPlusplus